export default __webpack_public_path__ + "static/media/coolectibles.890a253f.pdf";